import { render, staticRenderFns } from "./supplierServicePriceList.vue?vue&type=template&id=cf53e13e&"
import script from "./supplierServicePriceList.vue?vue&type=script&lang=js&"
export * from "./supplierServicePriceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports